<template>
    <ReportContainer>
      <template #filter>
        <b-form-group
          label="From">
          <b-form-datepicker  v-model="filters.collection.dateFrom"
            :date-format-options="{
              'year': 'numeric', 'month': 'long', 'day': 'numeric'
            }"/>
        </b-form-group>
         <b-form-group
          label="To">
          <b-form-datepicker  v-model="filters.collection.dateTo"
            :date-format-options="{
              'year': 'numeric', 'month': 'long', 'day': 'numeric'
            }"/>
        </b-form-group>
        <b-button variant="outline-primary" @click="onPreviewIncomeStatement">Preview</b-button>
      </template>
      <template #content>
        <ReportViewer :reportSource="file.src" :isLoading="file.isLoading"/>
      </template>
    </ReportContainer>
</template>

<script>
import { ReportApi } from '../../mixins/api'
import ReportContainer from '../components/ReportContainer'
import ReportViewer from '../components/ReportViewer'
export default {
  components: {
    ReportContainer,
    ReportViewer
  },
  mixins: [ ReportApi ],
  data() {
    return {
      reportSource: '',
      isLoading: false,
      filters:{
        collection: {
          dateFrom: new  Date(),
          dateTo: new  Date()
        }
      },
      file: {
        src: '',
        isLoading: false
      }
    }
  },
  methods: {
    onPreviewIncomeStatement() {
      this.file.src = ''
      this.file.isLoading = true
      const { dateFrom, dateTo } = this.filters.collection
      const params = { dateFrom, dateTo }
      this.incomeStatement(params).then(response  => {
        const file = new Blob([response.data], { type: "application/pdf" } )
          const reader = new FileReader();
          reader.onload = e => this.file.src = e.target.result
          reader.readAsDataURL(file);
          this.file.isLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .collection-detailed__container {
    height: 100%;
    width: 100%;
  }
</style>
